import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { changePasswordPath, needsPasswordChange } from '../utils/sessionAuth'

/** Redirect logged-in users with a temporary password to ChangePassword. */
function ForcePasswordChange() {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (!sessionStorage.getItem('id')) return
    if (!needsPasswordChange()) return
    if (location.pathname === '/ChangePassword') return
    const returnTo = `${location.pathname}${location.search || ''}`
    history.replace(changePasswordPath(returnTo === '/ChangePassword' ? '/' : returnTo))
  }, [history, location.pathname, location.search])

  return null
}

export default ForcePasswordChange
